import { BlockType } from 'pn-backend';
import React, { FC } from 'react';

import { Meta } from '~meta';
import { BlockProps } from '~types';

// Блок используется для хранения meta информации
export const MetaBlock: FC<BlockProps<BlockType.Meta>> = ({ compiled: { canonical } }) =>
  canonical ? <Meta canonical={canonical} /> : null;
